/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addTeamToProduct } from '../../actions/productActions';
import TeamCard from './teamCard';
import CustomSelect from '../Common/CustomSelect/SelectField';

class TeamsTab extends React.Component {
  state = {
    selectedTeamId: null
  };

  selectTeam = (option) => this.setState({ selectedTeamId: option.value });

  addTeam = () => {
    const { selectedTeamId } = this.state;
    const { product, orgTeams } = this.props;
    if (!selectedTeamId) {
      return null;
    }
    if (product.id) {
      this.props.addTeamToProduct(selectedTeamId, product.id);
    } else {
      const team = orgTeams.find((t) => t.id === Number(selectedTeamId));
      this.props.addTemporaryTeam(team);
    }
    this.setState({ selectedTeamId: null });
    return null;
  };

  generateTeamOptions = () => {
    const mappedTeams = this.props.orgTeams.reduce((acc, team) => {
      if (
        this.props.product &&
        !this.props.product.teams.some((t) => t.id === team.id)
      ) {
        acc.push({ label: team.short_name, value: team.id });
      }
      return acc;
    }, []);
    mappedTeams.unshift({ label: '', value: null });
    return mappedTeams;
  };

  selectedTeam = () => {
    return this.generateTeamOptions().find(
      (option) => option.value === this.state.selectedTeamId
    );
  };

  render() {
    const { product, orgTeams = [], allowEdit } = this.props;
    const { teams = [] } = product;
    return (
      <div className="teams-tab">
        <div className="team-select-container">
          <CustomSelect
            selectedOption={this.selectedTeam()}
            options={this.generateTeamOptions()}
            handleOptionChange={this.selectTeam}
            placeholder="Another new team"
            disabled={!allowEdit}
          />
          <button
            type="button"
            className="btn btn-xs button-lavender"
            onClick={this.addTeam}
            disabled={!allowEdit}
          >
            <strong>Add team</strong>
          </button>
        </div>
        <div className="col-sm-12 teams-list">
          {teams.map((team) => (
            <div key={team.id} className="col-sm-3">
              <TeamCard
                team={orgTeams.find((t) => t.id === team.id) || team}
                product={product}
                removeTemporaryTeam={this.props.removeTemporaryTeam}
                allowDelete={allowEdit}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

TeamsTab.propTypes = {
  product: PropTypes.object.isRequired,
  orgTeams: PropTypes.array
};

const mapStateToProps = (state) => {
  return {
    orgTeams: state.teamReducer.teams.filter((t) => !t.deleted_at)
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addTeamToProduct
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TeamsTab);
